class APIS {
	apis() {
		return {
			numbers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/conversations'
			},
			historyNumbers: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/history/conversations'
			},
			historyChat: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/history/chat'
			},
			inbound: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/list/inbound_messages'
			},
			outbound: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/list/wt_messages'
			},
			conversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/get/chat'
			},
			historyConversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/agent/history/chat/:number/:last_closed'
			},
			historyConversationsPagination: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/history/chat'
			},
			send_text: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/text'
			},
			send: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/:type'
			},
			email: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/email'
			},
			send_template: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/send/template'
			},
			agent_list_a: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentlist'
			},
			agent_admin_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentadminlist'
			},
			agent_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agents'
			},
			agent_listNew: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/ongoingagentlist'
			},
			transfer: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/forward/agent/:id'
			},
			shiftTickets: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/shift/ticket'
			},
			end: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/chat/update/:number'
			},
			end_ticket: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chat/close'
			},
			reset_group_message_count: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/messages/reset/group/:group_id'
			},
			reset_message_count: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/messages/reset'
			},
			block: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/toggle/customer/block/:number'
			},
			blockTicket: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customer/block'
			},
			agents_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agents'
			},
			agents_list2: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/list/agentlist'
			},
			agents_customer_list: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/backend/fetch/agent/customers'
			},
			agents_customer_conversations: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/conversations/ongoing'
			},
			unblock: {
				headers: {
					'xt-user-token': null
				},
				method: 'put',
				path: '/backend/toggle/customer/unblock/:number'
			},
			unblockTicket: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/customer/unblock'
			},
			allAgents: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/customers-agents'
			},
			inbound_messages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/list/inbound'
			},
			outbound_messages: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/list/outbound'
			},
			search_customer: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/search/customer'
			},
			unassignedChats: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/unassigned/conversations'
			},
			keywordMessageSearch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/keywordMessages'
			},
			call_recording: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/call/recording'
			},
		};
	}
}

export default new APIS();
